import type React from "react";

import { useRoutes } from "react-router-dom";

import { useProfileContext } from "contexts/ProfileContext/useProfileContext";
import { Container } from "shared/atoms/Container";
import { usePageContentOffsetTop } from "shared/styles/usePageContentOffsetTop";
import { userIsPartner } from "utils/profile/profileHelper";

import { ClinicPartnerInvitations, Invitations } from "./views";

export const InvitationsRoutes: React.FC = () => {
  const { profile } = useProfileContext();
  const offsetTop = usePageContentOffsetTop();
  const isPartner = userIsPartner(profile);

  const routes = useRoutes([
    {
      path: "/",
      element: isPartner ? <ClinicPartnerInvitations /> : <Invitations />,
    },
  ]);

  return <Container $pageContentOffsetTop={offsetTop}>{routes}</Container>;
};
